import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect } from 'react';
import { useSnackbar } from '@emburse/embark-core';
import login from '../../api/login';
import { $t, useTranslation } from '../../hooks/useTranslation';
import Login, { SystemStatuses } from './Login';
function AppLogin() {
    useTranslation();
    const { enqueueSnackbar } = useSnackbar();
    const submitLogin = useCallback(async () => {
        const username = document.getElementById('D53DFAFC76FEBB307AEA38378D6881DA');
        const password = document.getElementById('7CDB5079534DF37CD06C4E76D141534F');
        try {
            await login(username.value, password.value);
            window.location.href = '/';
        }
        catch (e) {
            enqueueSnackbar($t('The email address or password you entered is incorrect.'), {
                variant: 'error'
            });
        }
    }, [enqueueSnackbar]);
    useEffect(() => {
        const loginButton = document.getElementById('Login');
        if (loginButton) {
            loginButton.addEventListener('click', submitLogin);
        }
    }, [submitLogin]);
    return _jsx(Login, { Username: "", SystemStatus: SystemStatuses.spsOperational });
}
export default AppLogin;
